import { useTenantConfig } from '../../storefront/lib/hooks';

/** Whether the guide is on for this member: the tenant's switch, in the MLM portal. */
export function useTutorialEnabled(): boolean {
  const config = useTenantConfig().data;
  // A learning-mode portal hides the Vault and the kit grid these steps point at.
  return config?.memberTutorialEnabled === true && config.memberDashboardMode !== 'learning';
}
